import React from 'react';
import { MascotMark } from './Badge';
const NAV_LINKS = [{
  href: '#band',
  label: 'Band'
}, {
  href: '#shows',
  label: 'Shows'
}, {
  href: '#watch',
  label: 'Watch'
}, {
  href: '#photos',
  label: 'Photos'
}, {
  href: '#contact',
  label: 'Contact'
}];
export function SiteHeader() {
  return <nav className="sticky top-0 z-50 w-full border-b-2 border-[var(--vu-gold)]/60 bg-[var(--vu-black)]/95 px-4 py-1 shadow-[0_4px_18px_rgba(0,0,0,0.45)] backdrop-blur-sm" aria-label="Primary navigation" data-id="element-124" data-mp="1inbhbnzwf2id">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-5" data-id="element-125" data-mp="qxyuh5paqna2">
        <a href="#top" className="flex shrink-0 items-center gap-2.5 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" aria-label="Virtually Unknown home" data-id="element-126" data-mp="14woqsj4akixd">
          <MascotMark size={54} data-id="element-127" data-mp="2bcr235hd89rh" />
          <span className="font-cond text-base font-semibold uppercase leading-none tracking-[0.08em] text-[var(--vu-cream)] sm:text-lg" data-id="element-128" data-mp="2bbfo6cu7hlmn">
            Virtually Unknown
          </span>
        </a>

        <div className="flex items-center gap-3 overflow-x-auto font-cond text-xs uppercase tracking-[0.14em] text-[var(--vu-cream)] sm:gap-5 sm:text-sm" data-id="element-129" data-mp="2ehvhvd62snwu">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap border-b border-transparent py-2 transition-colors hover:border-[var(--vu-gold)] hover:text-[var(--vu-gold)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--vu-gold)]" data-id="element-130" data-mp="2ohcivhadudmh">
              {link.label}
            </a>)}
        </div>
      </div>
    </nav>;
}